import { ItrTypeExt } from './types';
import { ItrType, ProjectMilestoneType } from '@bechtel/types';
import { t } from '@lingui/macro';

export const itrTypeList: ItrTypeExt[] = [
  {
    description: t`Require foreman to certify pipe cleanliness for each spool as part of claiming progress milestone.`,
    value: ItrType.PIPE_CLEANLINESS,
  },
];

export const milestoneNoneType: ProjectMilestoneType = {
  id: 'None',
  name: 'None',
  itrRequired: false,
  projectItrConfig: [],
};
